import { HoldRequestDialogcomponent } from './dialogs/hold-request/hold-request-dialog.component';
// DIRECTIVES
import { FieldMatchesValidatorDirective } from './directives/field-matches-validator.directive';
import { PhoneDirective } from './directives/phone.directive';
import { MyNumberDirective } from './directives/number.directive';
import { MyNumberSlashDirective } from './directives/number-slash.directive';
import { CDKeyDirective } from './directives/cdkey.directive';
import { ZipCodeDirective } from './directives/zip.directive';
import { MonthYearMaskDirective } from './directives/month-year-mask.directive';

// BASE IMPORTS
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TopNavBarCrumbs } from './shared/topnavcrumbs/topnavcrumbs.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { AngularSvgIconModule } from 'angular-svg-icon';

import { MainComponent } from './views/main/main.component';
import { DashboardView } from './views/dashboard/dashboard.view';
import { OrderFormView } from './views/order-form/order-form.view';
import { BlankView } from './views/blank/blank.view';

import { NavMenuComponent } from './shared/navmenu/navmenu.component';
import { TopNavBarComponent } from './shared/topnavbar/topnavbar.component';
import { FooterComponent } from './shared/footer/footer.component';
import { BrowserModule } from '@angular/platform-browser';

import { SSLogoComponent } from './shared/ss-logo/ss-logo.component';

// PIPES
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe';
import { ProductNameWebSafePipe, ProductNamePipe, BillingCyclePipe } from './pipes/product-name-web-safe.pipe';
import { CapitalizeFirstLetterPipe } from './pipes/captialize_first_letter.pipe';
import { AddYearsToDatePipe } from './pipes/add-years-to-date.pipe';
import { DaysRemainingPipe } from './pipes/date-pipes';
import { CreditCardTypePipe } from './pipes/creditcard.pipe';


// PRIMENG IMPORTS
import { AccordionModule } from 'primeng/accordion';
import { TabViewModule } from 'primeng/tabview';
import { DropdownModule } from 'primeng/dropdown';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CalendarModule } from 'primeng/calendar';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CheckboxModule } from 'primeng/checkbox';
import { DragDropModule } from 'primeng/dragdrop';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { FullCalendarModule } from 'primeng/fullcalendar';
import { InputNumberModule } from 'primeng/inputnumber';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


// COMPONENTS
import { CreditCardAddComponent } from 'app/shared/credit-card-add/credit-card-add.component';
import { Paginator } from 'app/shared/paginator/paginator.component';
import { GooglePlacesComponent } from 'app/shared/google-places/google-places.component';

// DIALOG WINDOW COMPONENTS
import { ConfirmDialogComponent } from 'app/dialogs/confirm/confirm-dialog.component';
import { AddProductDialogComponent } from 'app/dialogs/add-product/add-product-dialog.component';
import { AddCreditCardDialogComponent } from 'app/dialogs/add-credit-card/add-credit-card-dialog.component';
import { AddGISDialogComponent } from 'app/dialogs/add-gis/add-gis-dialog.component';
import { CDKeyReassignDialogComponent } from 'app/dialogs/cdkey-reassign/cdkey-reassign-dialog.component';
import { CancellationRequestDialogComponent } from 'app/dialogs/cancellation-request/cancellation-request-dialog.component';
import { UpgradeProductDialogComponent } from 'app/dialogs/upgrade-product/upgrade-product-dialog.component';
import { EditCreditCardDialogComponent } from 'app/dialogs/edit-credit-card/edit-credit-card-dialog.component';
import { EventRegistrationDialogComponent } from 'app/dialogs/event-registration/event-registration-dialog.component';
import { ReactivateCDKeyDialogComponent } from 'app/dialogs/reactivate-cdkey/reactivate-cdkey-dialog.component';
import { YARDAddDialogComponent } from 'app/dialogs/yard-add/yard-add-dialog.component';
import { YARDCancellationRequestDialogComponent } from 'app/dialogs/yard-cancellation-request/yard-cancellation-request-dialog.component';
import { CompleteOrderDialogComponent } from 'app/dialogs/complete-order/complete-order-dialog.component';
import { PayInvoiceDialogComponent } from 'app/dialogs/pay-invoice/pay-invoice-dialog.component';
import { EventRescheduleDialogComponent } from './dialogs/event-reschedule/event-reschedule-dialog.component';
import { ReactivateLicenseDialogComponent } from './dialogs/reactivate-license/reactivate-license-dialog.component';
import { LoginFormComponent } from './authentication/signin/login-form/login-form.component';
import { ForgotPasswordFormComponent } from './authentication/signin/forgot-password-form/forgot-password-form.component';
import { TwoFactorChoiceFormComponent } from './authentication/signin/twofactor-choice-form/twofactor-choice-form.component';
import { TwoFactorCodeFormComponent } from './authentication/signin/twofactor-code-form/twofactor-code-form.component';
import { LoginDialogComponent } from './dialogs/auth-login/auth-login-dialog.component';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { SSCreditCardFormComponent } from './shared/ss-cc-form/ss-cc-form.component';
import { SSCreditCardFormNewComponent } from './shared/ss-cc-form-new/ss-cc-form-new.component';
import { ChangeBillingCycleDialogComponent } from './dialogs/change-billing-cycle/change-billing-cycle-dialog.component';
import { ThankYouComponent } from './order/components/thank-you/thank-you.component';

@NgModule({
    declarations: [
        // directives
        FieldMatchesValidatorDirective,
        PhoneDirective,
        MyNumberDirective,
        MyNumberSlashDirective,
        CDKeyDirective,
        ZipCodeDirective,
        MonthYearMaskDirective,
        // pipes
        AddYearsToDatePipe,
        CapitalizeFirstLetterPipe,
        SanitizeHtmlPipe,
        ProductNameWebSafePipe,
        ProductNamePipe,
        BillingCyclePipe,
        DaysRemainingPipe,
        CreditCardTypePipe,
        // main view components
        MainComponent,
        // layout
        DashboardView,
        OrderFormView,
        BlankView,
        // shared components
        NavMenuComponent,
        TopNavBarComponent,
        FooterComponent,
        TopNavBarCrumbs,
        SSLogoComponent,
        Paginator,
        CreditCardAddComponent,
        GooglePlacesComponent,
        // dialog window components
        ConfirmDialogComponent,
        AddProductDialogComponent,
        AddCreditCardDialogComponent,
        AddGISDialogComponent,
        CDKeyReassignDialogComponent,
        CancellationRequestDialogComponent,
        EditCreditCardDialogComponent,
        UpgradeProductDialogComponent,
        EventRegistrationDialogComponent,
        ReactivateCDKeyDialogComponent,
        YARDAddDialogComponent,
        YARDCancellationRequestDialogComponent,
        CompleteOrderDialogComponent,
        PayInvoiceDialogComponent,
        EventRescheduleDialogComponent,
        ReactivateLicenseDialogComponent,
        LoginFormComponent,
        ForgotPasswordFormComponent,
        TwoFactorChoiceFormComponent,
        TwoFactorCodeFormComponent,
        LoginDialogComponent,
        HoldRequestDialogcomponent,
        SSCreditCardFormComponent,
        SSCreditCardFormNewComponent,
        ChangeBillingCycleDialogComponent,
        ThankYouComponent
    ],
    imports: [
        BrowserModule,
        RouterModule,
        HttpClientModule,
        AngularSvgIconModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        BsDropdownModule.forRoot(),
        OverlayPanelModule,
        AccordionModule,
        TabViewModule,
        DropdownModule,
        CalendarModule,
        CheckboxModule,
        DragDropModule,
        DynamicDialogModule,
        FullCalendarModule,
        InputNumberModule,
        BrowserAnimationsModule,
        InputSwitchModule,
        CreditCardDirectivesModule,
    ],
    exports: [
        AngularSvgIconModule,
        // directives
        FieldMatchesValidatorDirective,
        PhoneDirective,
        MyNumberDirective,
        MyNumberSlashDirective,
        CDKeyDirective,
        ZipCodeDirective,
        MonthYearMaskDirective,
        // pipes
        AddYearsToDatePipe,
        ProductNameWebSafePipe,
        ProductNamePipe,
        BillingCyclePipe,
        DaysRemainingPipe,
        CreditCardTypePipe,
        // common
        CommonModule,
        // layout
        MainComponent,
        DashboardView,
        OrderFormView,
        BlankView,
        // shared components
        NavMenuComponent,
        TopNavBarComponent,
        FooterComponent,
        TopNavBarCrumbs,
        SSLogoComponent,
        Paginator,
        CreditCardAddComponent,
        GooglePlacesComponent,
        SSCreditCardFormComponent,
        SSCreditCardFormNewComponent,
        AccordionModule,
        TabViewModule,
        OverlayPanelModule,
        DropdownModule,
        InputSwitchModule,
        CalendarModule,
        CheckboxModule,
        DragDropModule,
        DynamicDialogModule,
        FullCalendarModule,
        InputNumberModule,
        BrowserAnimationsModule,
        // dialog components
        ConfirmDialogComponent,
        AddProductDialogComponent,
        AddCreditCardDialogComponent,
        AddGISDialogComponent,
        CDKeyReassignDialogComponent,
        CancellationRequestDialogComponent,
        EditCreditCardDialogComponent,
        UpgradeProductDialogComponent,
        EventRegistrationDialogComponent,
        ReactivateCDKeyDialogComponent,
        YARDAddDialogComponent,
        YARDCancellationRequestDialogComponent,
        CompleteOrderDialogComponent,
        PayInvoiceDialogComponent,
        EventRescheduleDialogComponent,
        ReactivateLicenseDialogComponent,
        LoginFormComponent,
        ForgotPasswordFormComponent,
        TwoFactorChoiceFormComponent,
        TwoFactorCodeFormComponent,
        LoginDialogComponent,
        ChangeBillingCycleDialogComponent,
        ThankYouComponent
    ]
})
export class SharedAppModule { }
